import { useSelector } from 'react-redux'
import { TableIndustryAnalysis } from '../../common/table'
import {
  changeActiveRow,
  selectActiveRowGroupId,
  selectCellData,
  selectData,
  selectHeaders,
  selectIds,
  selectRowGroup,
} from './store/slice'

export const EarningQualityTable = ({ isDynamicReport }) => {
  const activeRowGroupId = useSelector(selectActiveRowGroupId)
  const ids = useSelector(selectIds)
  const headers = useSelector(selectHeaders)

  return (
    <TableIndustryAnalysis
      isDynamicReport={isDynamicReport}
      dataTable={{
        activeRowGroupId,
        changeActiveRow,
        headers,
        ids,
        selectCellData,
        selectData,
        selectRowGroup,
      }}
    />
  )
}
